const report = {
  salesReport: () => `store/report/sales`,
  salesReturn: () => `store/report/sales-return`,
  collection: () => `store/report/collection`,
  customer: () => `store/report/customer`,
  inventoryReport: () => `store/report/inventory`,
  gstOutputReport: () => `store/report/gst-output`,
  glAccountReport: () => `admin/report/gl-account`,
  generalAccountList: () => 'admin/report/account/search',
  dailyActivityReport:()=> 'store/report/daily-activity',
  inventoryAdditionalInvoiceWiseReport: () => `store/report/inventory-addition`,
  inventoryAdditionalBarcodeWiseReport: () => `store/report/inventory-addition-barcode-wise`,
  inventoryMovement: () => `store/report/inventory-movement`,
  barcodeAuditReport: () => `store/report/barcode-audit-trail`,
  barcodeSearch:()=>`store/report/barcode/search`,

  // for e-com
  eComOrder:()=>'store/report/ecom-orders',
}
export default report